import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import _ from 'lodash';
import Metrics from 'services/metrics';
import { getFingerprint } from 'reducers/payments/cybersource';
import PropTypes from 'prop-types';
import * as actions from '../../../actions/response';
import * as actionsUser from '../../../action-creators/user';
import * as constants from '../../../constants';
import RequestManager from '../../../requests/RequestManager';
import { converter } from '../../../helpers/converter';
import LoadingBlocks from '../../forms/LoadingBlocks';
import PurchaseButtonSuscTask from '../../../requests/tasks/PurchaseButtonSuscTask';
import PaywayConfirmTask from '../../../requests/tasks/PaywayConfirmTask';
import { getCancelSuscription } from '../../../services/api/payway/cancelSuscription';

const classButtonInactive = 'btn btn-default close-modal btn-block';
const classButtonActive = 'btn btn-primary close-modal btn-block';

class ModalUnSuscribeConfirm extends React.Component {
  static defaultProps = {
    title: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      waitingResponse: true,
      message: this.getInitMessage(),
      onResponse: false,
      canceled: false,
      titleModal: this.props.title,
    };
    this.closeModal = this.closeModal.bind(this);
    this.unSuscribeConfirm = this.unSuscribeConfirm.bind(this);
    this.checkKey = this.checkKey.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.downsell = this.downsell.bind(this);
    this.hideTitle = this.hideTitle.bind(this);
    this.showDownsell = false;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.title !== nextProps.title) {
      this.setState({
        titleModal: nextProps.title,
      });
    }
  }

  hideTitle() {
    this.setState({
      titleModal: '',
    });
  }

  handleCancelBtn = () => {
    Metrics.newEvent({
      eventCategory: 'Suscripción',
      eventAction: this.props.provider,
      eventLabel: 'Cancelar Suscripción - Volver',
    });
    this.closeModal();
  };

  closeModal() {
    this.props.closeModal('UnSuscribeConfirm');
  }

  onSuccess = data => {
    this.hideTitle();
    let cancelMessage = 'Suscripción cancelada';
    let paywayDataCanceled = null;
    let expirationDate = '';
    let cancelMsg = '';

    Metrics.newEvent({
      eventCategory: 'Suscripción',
      eventAction: this.props.provider,
      eventLabel: 'Cancelación Exitosa',
    });

    if (
      data.msg &&
      data.msg.indexOf('CV') > -1 &&
      this.props.translations.CANCEL_SUSCRIPTION_IS_CANCELED
    ) {
      cancelMessage = (
        <div>
          <p
            className="padding-top-2"
            dangerouslySetInnerHTML={{
              __html: this.props.translations.CANCEL_SUSCRIPTION_IS_CANCELED,
            }}
          />
        </div>
      );
    }

    if (
      data.msg &&
      this.props.translations &&
      this.props.translations[data.msg]
    ) {
      paywayDataCanceled = this.props.user.paywayData.filter(
        p =>
          p.purchase_data !== '' &&
          p.purchase_data.purchase_id === this.props.purchase_id,
      );
      if (paywayDataCanceled && paywayDataCanceled.length > 0) {
        expirationDate = paywayDataCanceled[0].purchase_data.expiration.split(
          ' ',
        )[0];
      }
      cancelMsg =
        expirationDate !== ''
          ? this.props.translations[data.msg].replace('{@DATE}', expirationDate)
          : this.props.translations[data.msg];
      cancelMessage = (
        <div>
          <p
            className="padding-top-2"
            dangerouslySetInnerHTML={{ __html: cancelMsg }}
          />
        </div>
      );
    }
    /*
    if(this.props.provider === "FOX") {
      cancelMessage = <div><p className='padding-top-2' dangerouslySetInnerHTML={{__html: this.props.translations["PGS_PDD_00001"] } }></p></div>;
    }
*/

    this.setState({
      message: cancelMessage,
      waitingResponse: false,
      onResponse: true,
      canceled: true,
    });
    this.props.removeUserSusc(this.props.purchase_id);
  };

  onFailed = data => {
    this.hideTitle();
    const convertable = data.code;

    data.message = (
      <div>
        <p
          className="padding-top-2"
          dangerouslySetInnerHTML={{
            __html: converter.convertApaUnicode(
              this.props.translations,
              convertable,
              'Ha ocurrido un error',
            ),
          }}
        />
      </div>
    );

    this.setState({ canceled: true });
    this.setState({ message: data.message });
    this.setState({ onResponse: true });
  };

  unSuscribeConfirm = async () => {
    const { purchase_id, provider } = this.props;
    Metrics.newEvent({
      eventCategory: 'Suscripción',
      eventAction: provider,
      eventLabel: 'Cancelar Suscripción - Si',
    });
    const params = Object.assign({}, purchase_id && { purchase_id });

    this.setState({ waitingResponse: true });
    try {
      const request = await getCancelSuscription(params);
      const { response, errors, msg } = request;
      if (response.success) {
        this.onSuccess(response);
      } else {
        const code = _.get(errors, ['error', '0'], msg);
        this.onFailed({ code });
      }
    } catch (e) {
      this.onFailed({ code: 'ERROR' });
    }
  };

  getOKButton() {
    return (
      <div className="col-lg-3 col-md-3 col-sm-4 col-xs-5 padding-top-05 pull-right">
        <Button className={classButtonInactive} onClick={this.closeModal}>
          Aceptar
        </Button>
      </div>
    );
  }

  getInitMessage() {
    return (
      <div>
        <i
          className="fa text-center fa-3x fa-exclamation-triangle"
          aria-hidden="true"
        />
        <p
          className="padding-top-2"
          dangerouslySetInnerHTML={{ __html: this.props.message }}
        />
      </div>
    );
  }

  fetchData() {
    const purchaseTask = new PurchaseButtonSuscTask({
      object_type: 'A',
      forzar_siempre_vis_desde_app: 1,
    });
    return RequestManager.addRequest(purchaseTask).then(result => {
      const defaultModes = result.payTypes.reduce(
        (p, c) => p.concat(c.payModes),
        [],
      );

      return {
        payTypes: result.payTypes,
        modes: result.payModes || defaultModes,
      };
    });
  }

  downsell() {
    this.setState({
      waitingResponse: true,
      canceled: false,
    });
    const { extradata, fingerprint, userInfo } = this.props;
    const gateway = _.get(extradata, ['payway', 'gateway']);
    const userData = JSON.parse(
      localStorage.getItem('loginInfo.logged_user_data'),
    );

    const params = {
      payway: gateway,
      token: userData.token,
    };

    if (/buyConfirm/i.test(this.urlDownsell)) {
      params.buyToken = this.buyToken;
      switch (gateway) {
        case 'claropagosgate':
          const cardToken = _.get(extradata, [
            'payway',
            'gateway_data',
            'token',
          ]);
          const cardType = _.get(extradata, [
            'payway',
            'gateway_data',
            'card_type',
          ]);
          const clientId = _.get(userInfo, [
            'paywayProfile',
            'paymentMethods',
            '0',
            'account',
          ]);
          params.extra_params = JSON.stringify({
            device_fingerprint: fingerprint,
            card_token: cardToken,
            card_type: cardType,
            client_id: clientId,
          });
          break;
      }
    }

    let message = converter.convertApaUnicode(
      this.props.translations,
      'TEXT_PGS_DOWNSELL_MEXICO_TELMEXMEXICO_ABONO_FOX_PLUS_PROMOGATE',
      'Felicidades',
    );

    const btnLabel = converter.convertApaUnicode(
      this.props.translations,
      'payway_confirm_fox_ok',
      'Comenzar a disfrutar',
    );

    const confirmTask = new PaywayConfirmTask(this.urlDownsell, params);
    return RequestManager.addRequest(confirmTask)
      .then(result => {
        this.props.closeModal();
        if (result.response.code) {
          message = converter.convertApaUnicode(
            this.props.translations,
            result.response.code,
            'Felicidades',
          );
        }

        message = message.replace('{@EMAIL}', userData.username);

        const modal = {
          modalType: 'SuccessSimple',
          props: {
            message,
            btnLabel,
          },
        };
        this.props.showModal(modal);
      })
      .catch(error => {
        this.props.closeModal();
        const errorMessage = _.get(
          error,
          ['completeError', 'errors', '0', 'code'],
          '',
        );
        const modal = {
          modalType: 'ErrorSimple',
          props: {
            message: converter.convertApaUnicode(
              this.props.translations,
              errorMessage,
              'Ha ocurrido un error inesperado. Por favor intente de nuevo.',
            ),
          },
        };
        this.props.showModal(modal);
      });
  }

  componentDidMount() {
    this.checkKey();
    this.urlDownsell = '';
    if (this.showDownsell === true) {
      this.fetchData()
        .then(result => {
          result.modes.map(data => {
            if (
              this.props.extradata.payway.gateway === data.gateway &&
              this.props.extradata.provider === data.producttype
            ) {
              this.urlDownsell = data.buyLink;
              this.buyToken = data.buyToken;
            }
          });
          this.setState({
            waitingResponse: false,
          });
        })
        .catch(err => {
          const modal = {
            modalType: 'ErrorSimple',
            props: {
              message:
                err.message ||
                converter.convertApaUnicode(
                  this.props.translations,
                  'bad_response_error_msg',
                ),
            },
          };
          this.props.showModal(modal);
        });
    } else {
      this.setState({
        waitingResponse: false,
      });
    }
  }

  checkKey() {
    if (
      this.props.provider === 'FOX' &&
      Array.isArray(this.props.extradata.keys) &&
      (this.props.extradata.keys.indexOf('Telmexmexico_abono_FOX_PLUS') !==
        -1 ||
        this.props.extradata.keys.indexOf(
          'Telmexmexico_abono_FOX_PLUS_PROMO',
        ) !== -1)
    ) {
      this.showDownsell = true;
    } else {
      this.showDownsell = false;
    }
  }

  render() {
    this.checkKey();
    let proveedor = 'Fox';
    if (this.props.provider === 'AMCO') {
      proveedor = constants.VENDORS_DEMO[this.props.provider];
    } else if (this.props.provider === 'FOX') {
      proveedor = constants.VENDORS_DEMO[this.props.provider];
    }
    const { titleModal } = this.state;
    return (
      <Modal show>
        <Modal.Header>
          <Button className="close close-modal" onClick={this.closeModal}>
            x
          </Button>
          {/* NOTA: esta hardcoeado el texto */}
          <h4 className="text-left">{`${titleModal}`}</h4>
        </Modal.Header>
        <Modal.Body className="modal-body text-center success">
          {this.state.message}
        </Modal.Body>
        <Modal.Footer>
          {this.state.onResponse && this.getOKButton()}

          {!this.state.waitingResponse && !this.state.canceled && (
            <div className="footer-modal-button flex-end">
              <div className="col-lg-3 col-md-3 col-sm-4 col-xs-5 padding-top-05">
                <Button
                  className={classButtonActive}
                  onClick={this.unSuscribeConfirm}
                >
                  {this.props.sibtn}
                </Button>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-4 col-xs-5 padding-top-05">
                <Button
                  className={classButtonInactive}
                  onClick={this.handleCancelBtn}
                >
                  {this.props.nobtn}
                </Button>
              </div>
            </div>
          )}

          {this.state.waitingResponse && !this.state.canceled && (
            <LoadingBlocks />
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  translations: state.translations,
  router: state.routing,
  user: state.user,
  pbisusc: state.card.purchaseInfoSusc,
  config: state.config,
  card: state.card,
  modes: state.modes,
  fingerprint: getFingerprint(state),
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  removeUserSusc(purchase_id) {
    dispatch(actionsUser.removeUserSusc(purchase_id));
  },
  showModal(modal) {
    dispatch(actions.showModal(modal));
  },
});

ModalUnSuscribeConfirm.propTypes = {
  provider: PropTypes.string,
  sibtn: PropTypes.string,
  dowsellbtn: PropTypes.node,
  nobtn: PropTypes.string,
  extradata: PropTypes.object,
  showModal: PropTypes.func,
  closeModal: PropTypes.func,
  translations: PropTypes.object,
  fingerprint: PropTypes.string,
  userInfo: PropTypes.object,
  message: PropTypes.string,
  title: PropTypes.string,
  user: PropTypes.object,
  purchase_id: PropTypes.string,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalUnSuscribeConfirm);
